<template>
  <div class="animated fadeIn">
    <Forms ref="frmGroup"
      :title="'CADASTRO DE FINALIZAÇÕES DE CONVERSAS'"
      :showClearButton="true"
      :showSaveButton="true"
      :showBackButton="true"
      v-on:Clear="onClear"
      v-on:Back="onBack"
      v-on:Save="openConfirmationModal">
      <div class="form-group row">
        <div v-if="!isEdit" class="col-md-3">
          <label for="txtData"><small v-if="form.dataInicial.required" class="text-danger">*</small>Data de criação</label>
          <div class="input-group">
            <b-form-input type="date"
                          id="txtData"
                          name="txtData"
                          v-model="form.dataInicial.value"
                          :required="form.dataInicial.required"
                          :state="form.dataInicial.state"/>
          </div>
        </div>
        <div v-if="!isEdit" class="col-md-3">
          <label><small v-show="form.tipo.required" class="text-danger">*</small>Tipo de finalização</label>
          <div class="input-group">
            <b-form-input type="text" id="tipo" name="tipo" value="" v-model="form.tipo.value"
                          :maxlength="15" :required="form.tipo.required" :state="form.tipo.state" />
          </div>
        </div>
        <div v-if="!isEdit" class="col-md-3">
          <label><small v-show="form.descricao.required" class="text-danger">*</small>Descrição</label>
          <div class="input-group">
            <b-form-textarea rows="3" max-row="6" id="descricao" name="descricao" v-model="form.descricao.value"
                             :maxlength="form.descricao.maxlength" :required="form.descricao.required" :state="form.descricao.state" />
          </div>
        </div>
        <div class="col-md-3">
        <label><small v-show="form.condicao.required" class="text-danger">*</small>Condição</label>
        <div class="input-group">
          <b-form-radio-group v-model="form.condicao.value">
            <b-form-radio value="1">Positivo</b-form-radio>
            <i class="fa fa-thumbs-up text-success"></i>
            <div></div>
            <b-form-radio value="0">Negativo</b-form-radio>
            <i class="fa fa-thumbs-down text-danger"></i>
            <div></div>
            <b-form-radio value="null">Neutro</b-form-radio>
            <i class="fa fa-hand-paper text-warning"></i>
          </b-form-radio-group>
        </div>
      </div>
      </div>
    </Forms>

    <AddConfirmation
      ref="AddConfirmationModal"
      warnText="Após o salvamento, somente será possível editar o campo condição positiva ou negativa. A exclusão não será permitida. Deseja confirmar esta operação?"
      :saveFunction="onSave"
    />
    <AddConfirmation
      v-if="isEdit"
      ref="AddConfirmationModal"
      warnText="Deseja realmente salvar?"
      :saveFunction="onSave"
    />
  </div>
</template>

<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import { toast, loading } from '@/shared/utils/UIHelper'
import { advancedOnException } from '@/components/tools/Utils'

import TiposFinalizacaoModel from '@/shared/models/configurations/tiposfinalizacaomodel.js'
import TiposFinalizacaoForm from './TiposFinalizacao-form.js'
import TiposFinalizacaoRepository from '@/shared/http/repositories/configurations/tipofinalizacao.js'
import Tools from '@/components/tools/Tools.js'

import AddConfirmation from '@/components/UI/confirmation/addConfirmation.vue'

export default {
  name: 'TiposFinalizacaoAdd',
  mixins: [ActionsForm],
  data () {
    return {
      data: TiposFinalizacaoModel,
      form: TiposFinalizacaoForm,
      isEdit: false
    }
  },
  components: {
    AddConfirmation
  },
  methods: {
    onBack () {
      this.$emit('Back')
    },
    onLoad () {
      this.onClear()
    },
    onEdit (obj) {
      this.isEdit = true
      loading.push()

      if (obj) {
        Tools.SetValueInForm(this.form, this.data, obj)
        if (obj.condicao !== undefined) {
          this.form.condicao.value = obj.condicao === true ? '1' : obj.condicao === false ? '0' : 'null'
        }
      }
      loading.pop()
    },
    onClear () {
      var date = new Date()
      this.data.id = null
      this.form.tipo.value = ''
      this.form.dataInicial.value = `${date.getFullYear()}-${((date.getMonth() + 1) + '').padStart(2, '0')}-${(date.getDate() + '').padStart(2, '0')}`
      this.form.dataFinal.value = ''
      this.form.condicao.value = '1' // Valor padrão como "Positivo"
    },
    onCreate () {
      loading.push()

      if (this.data.dataInicial) {
        this.data.dataInicial = this.data.dataInicial + 'T' + this.moment().format('HH:MM:SS.mmmmm')
      }
      if (this.data.dataFinal) {
        this.data.dataFinal = this.data.dataFinal + 'T' + this.moment().format('HH:MM:SS.mmmmm')
      }

      // Converte o valor de 'condicao' para 0, 1 ou null
      this.data.condicao = this.form.condicao.value === 'null' ? null : parseInt(this.form.condicao.value)

      TiposFinalizacaoRepository.Create(this.data)
        .then((response) => {
          loading.close()
          this.$emit('Back')
          toast.success(this.$lang.Common.Alerts.Success)
        })
        .catch((error) => advancedOnException(error, this.$lang))
      loading.close()
    },
    onUpdate () {
      loading.push()

      if (this.data.dataInicial) {
        this.data.dataInicial = this.data.dataInicial + 'T' + this.moment().format('HH:MM:SS.mmmmm')
      }
      if (this.data.dataFinal) {
        this.data.dataFinal = this.data.dataFinal + 'T' + this.moment().format('HH:MM:SS.mmmmm')
      }

      this.data.id = parseInt(this.data.id)
      this.data.condicao = this.form.condicao.value === 'null' ? null : parseInt(this.form.condicao.value) // Converte para 0, 1 ou null

      TiposFinalizacaoRepository.Update(this.data)
        .then((response) => {
          loading.close()
          this.$emit('Back')
          toast.success(this.$lang.Common.Alerts.Success)
        })
        .catch((error) => advancedOnException(error, this.$lang))
      loading.close()
    },
    openConfirmationModal () {
      this.$nextTick(() => {
        this.$refs['AddConfirmationModal'].showModal()
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/parametros_atendimento/TiposFinalizacao/components/add/TiposFinalizacaoAdd.vue